// Traderz Life — minimal theme JS
document.addEventListener('change', function (e) {
  var f = e.target.closest('[data-cart-qty]');
  if (f) { f.closest('form').submit(); }
});
document.addEventListener('change', function (e) {
  if (!e.target.matches('[data-variant-select]')) return;
  var form = e.target.closest('form');
  if (!form) return;
  var id = e.target.value;
  var hidden = form.querySelector('[name="id"]');
  if (hidden) hidden.value = id;
  var priceEl = document.querySelector('[data-variant-price]');
  var opt = e.target.selectedOptions[0];
  if (priceEl && opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
});
